module.exports = __webpack_public_path__ + "img/17400.13e21866.jpg";